var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMifinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 734.58 734.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-11,.cls-4{mix-blend-mode:soft-light;}.cls-5{fill:#e7e6e6;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{mix-blend-mode:multiply;opacity:0.71;fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:#1887b2;mix-blend-mode:darken;opacity:0.57;}.cls-11{fill:#fff;}.cls-12{fill:#2d9dd3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 381.76,
    y1: 297.17,
    x2: 540.6,
    y2: 297.17,
    gradientTransform: "translate(-33 4.45) rotate(0.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffa220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa61c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffc000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fdc200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f6c900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f5cb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f3c200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f0b100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#efab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b74600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 381.76,
    y1: 298.58,
    x2: 540.6,
    y2: 298.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 745.15,
    y1: 41.07,
    x2: 904.75,
    y2: 41.07,
    gradientTransform: "matrix(0.93, 0.21, -0.23, 1, -453.37, 138.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c59252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#eba31c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fdac03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f6ab0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e9aa1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e4a925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e7ac21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f4b70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fcbe04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 767.3,
    y1: -3.89,
    x2: 752.79,
    y2: 73.84,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3838.1,
    y1: -5431,
    x2: 3951.15,
    y2: -5317.95,
    gradientTransform: "matrix(-0.08, 0.92, -0.64, -0.05, -2776.24, -3527.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 535.91,
    y1: 382.92,
    x2: 252.76,
    y2: 252.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#001f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#004b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00799f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0094c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00a8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00b4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00b8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00b6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#01aeec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#03a2da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0691c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0788b3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499.88,294.78a19.74,19.74,0,0,1,1.23,1.89,50.21,50.21,0,0,0-4.53-12c-16.62-30.47-62.8-21.35-108.87,13.16a173.94,173.94,0,0,0-32.43,31.59c5.73,3.11,10.92,7.5,15.93,11.24a67,67,0,0,0,9.72,5.9c2.92-3.38,5.95-6.72,9.13-10C431.1,294.27,483.33,272.75,499.88,294.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.78,320.61l.86-.25c1.47-9.53.88-17.78-2.53-23.69A76.33,76.33,0,0,1,502.78,320.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M501,296.52a19.83,19.83,0,0,0-1.24-1.89l-.19-.21c.37,1.14.7,2.33,1,3.53a20.67,20.67,0,0,1,1.31,2.67C501.65,299.22,501.34,297.86,501,296.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M387.25,299.72c45.92-34.77,92.06-44.15,108.81-13.78a47.37,47.37,0,0,1,3.58,8.42l.19.21a19.74,19.74,0,0,1,1.23,1.89,49.54,49.54,0,0,0-4.58-11.95c-16.74-30.37-62.89-21-108.8,13.78a169.37,169.37,0,0,0-42.3,46.22l.26.34A169.73,169.73,0,0,1,387.25,299.72Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.2 288.93 268.19 288.93 268.2 288.93 268.2 288.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.13,329.74c-4.26-3.59-8.57-7-12.55-10.86a206.5,206.5,0,0,1-26.38,26c-41.1,34-85.38,45.21-98.9,25.13-.21-.31-.4-.64-.59-1A42.25,42.25,0,0,1,230,356.6a47.36,47.36,0,0,1,.43-25.8c-6.26,12.69-8,25.25-4.05,36,10.52,28.37,57.11,33.15,104.09,10.67,21.89-10.47,40-25,52-40.44C379.69,334.59,377,332.12,374.13,329.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M274.54,287.33a28.22,28.22,0,0,0-6.47,1.29l.13.31-.38-.18c-9.07,6.46-9.37,6.5.37.18a103.6,103.6,0,0,0-16,12.26A111.32,111.32,0,0,0,232,327.66h0c-.56,1-1.11,2.08-1.62,3.13a47.36,47.36,0,0,0-.43,25.8,42.25,42.25,0,0,0,5.74,12.45,42.6,42.6,0,0,1-5.48-20.38c.17-17.87,15.3-41.5,25.56-50.33,5.81-5,11.27-6.91,16.1-7.33A13.29,13.29,0,0,1,274.54,287.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M313.74,360.69c19.25-12,36.59-28.43,42-35.43l3.12-3.41c2.44-2.3,5.47-7,7.87-9.21,6.13-3.18,17.54-11.16,29.49-19.1,5.14-3.41,10.31-6.76,13.23-8.34l14,23.21c-8.75,5.68-31.16,24.59-39.07,31.33-2.5,2.12.48-2.54-1.86-.34l-16.76,15a166,166,0,0,1-38.05,24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M493.44,280.06c34.2,64.7-43.62,95.09-84.45,50.43-17.2-21.61-19.1-32.4-29.84-43.41-45.87-44.59-112-16.88-146.37,39,4.56-5.47,33.62-38.61,75.86-33.33,32.65,4.08,38,45.88,86.3,70.55C449.75,391.3,548.3,353.4,493.44,280.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M396.4,361.64c-48.31-24.67-53.65-66.48-86.3-70.56C269.8,286,241.51,316,235,323.47c0,0,0,.08,0,.12,8.57-9.43,35.81-35.49,73.62-30.76,32.65,4.08,38,45.89,86.3,70.56,33.94,17.33,84.64,9.38,105.31-16.59C478.74,371.38,429.57,378.57,396.4,361.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M495.12,282.18c-.56-.77-1.1-1.54-1.68-2.32,33.49,63.37-40.46,93.8-81.88,53.08C452.49,374.9,527.18,345.17,495.12,282.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M266,415a4.87,4.87,0,0,0-.85-.26c-2.3-.59-8-.78-9.84.72l-.1.09a3.15,3.15,0,0,0-.73,1,236.86,236.86,0,0,0-14.8,22.13l-13.77-22.08-.05-.11a3.12,3.12,0,0,0-.76-1l-.09-.08c-1.6-1.33-6.39-1.29-9-.84a7.26,7.26,0,0,0-1.81.43,2.83,2.83,0,0,0-1.73,2.57v46.61c0,.93.43,2.56,3.31,3a20.1,20.1,0,0,0,2.89.18c2,0,6.21,0,6.21-3.18V437.33c.9,1.42,2.61,4.2,4.5,7.69q3.94,7.29,5.29,9.53l.53,1a7,7,0,0,0,1.77,1.84,6.83,6.83,0,0,0,5,.78,3.25,3.25,0,0,0,1.16-.58,8.57,8.57,0,0,0,2-1.9l1.2-2.11q.87-1.51,4.08-7.56t4.88-8.81s0,5.05,0,5.33v21.7c0,3.18,4.19,3.18,6.2,3.18s6.2,0,6.2-3.18V417.61A2.83,2.83,0,0,0,266,415Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M281.08,433.54c-3.95,0-4.49.71-4.49,1.48v29.76c0,.76.54,1.47,4.49,1.47s4.5-.71,4.5-1.47V435C285.58,434.25,285,433.54,281.08,433.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M281.08,468c-2,0-6.2,0-6.2-3.18V435c0-3.18,4.19-3.18,6.2-3.18s6.21,0,6.21,3.18v29.76C287.29,468,283.1,468,281.08,468Zm-2.79-3.63a17.86,17.86,0,0,0,5.59,0V435.47a17.86,17.86,0,0,0-5.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M326.44,416.7H300.51c-2.72.09-4.11.34-4.11,1.46v46.62c0,.76.54,1.47,4.47,1.47s4.48-.71,4.48-1.47V445.52h18.53c1.43,0,2.35-1.62,2.35-4.13s-.92-4.14-2.35-4.14H305.35V425h21.09c1.43,0,2.35-1.62,2.35-4.13S327.87,416.7,326.44,416.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M300.88,468c-2,0-6.18,0-6.18-3.18V418.16c0-3,3.47-3.09,5.76-3.16h26c1.87,0,4.06,1.53,4.06,5.85s-2.19,5.84-4.06,5.84H307.05v8.86h16.83c1.87,0,4.06,1.53,4.06,5.85s-2.19,5.84-4.06,5.84H307.05v17.55C307.05,468,302.88,468,300.88,468Zm-2.77-3.63a17.49,17.49,0,0,0,5.53,0V443.82h20.24c.18-.06.65-.78.65-2.43s-.47-2.37-.64-2.44H303.64V423.27h22.8c.11,0,.65-.65.65-2.43s-.54-2.4-.64-2.44v0H300.51a14.34,14.34,0,0,0-2.4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M394.2,416.7c-3.94,0-4.48.77-4.48,1.52V449L368.5,417.57l-.1-.12c-1-1-6.54-.83-7.8-.3a1.15,1.15,0,0,0-.84,1.07v46.5c0,.49,0,1.52,4.47,1.52s4.48-1,4.48-1.52V434l21.23,31.36c.5.69,2.34.93,4.13.93a14,14,0,0,0,3.51-.36c.9-.28,1.09-.8,1.09-1.18v-46.5C398.67,417.47,398.14,416.7,394.2,416.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M394.07,468c-3.89,0-5-.94-5.52-1.64l-18.14-26.8v25.2c0,3.22-4.17,3.22-6.18,3.22s-6.17,0-6.17-3.22v-46.5a2.84,2.84,0,0,1,1.89-2.65c1.28-.53,7.79-1.18,9.65.67l.31.38L388,443.4V418.22c0-3.23,4.33-3.23,6.18-3.23s6.17,0,6.17,3.23v46.5a3,3,0,0,1-2.27,2.81A16.06,16.06,0,0,1,394.07,468Zm-2.83-3.75a8.19,8.19,0,0,0,2.83.34,14.57,14.57,0,0,0,2.89-.24V418.64a16,16,0,0,0-5.53,0v35.89l-24.22-35.82a16.21,16.21,0,0,0-5.74-.06V464.3a16,16,0,0,0,5.53,0V428.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M415,416.68c-3.95,0-4.5.71-4.5,1.48v46.62c0,.76.55,1.47,4.5,1.47s4.5-.71,4.5-1.47V418.16C419.49,417.39,419,416.68,415,416.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M415,468c-2,0-6.2,0-6.2-3.18V418.16c0-3.18,4.19-3.18,6.2-3.18s6.2,0,6.2,3.18v46.62C421.19,468,417,468,415,468Zm-2.8-3.63a17.93,17.93,0,0,0,5.6,0V418.61a17.93,17.93,0,0,0-5.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.25,416.68c-4,0-4.5.71-4.5,1.48v46.62c0,.76.54,1.47,4.5,1.47s4.5-.71,4.5-1.47V418.16C347.75,417.39,347.2,416.68,343.25,416.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.25,468c-2,0-6.2,0-6.2-3.18V418.16c0-3.18,4.19-3.18,6.2-3.18s6.2,0,6.2,3.18v46.62C349.45,468,345.26,468,343.25,468Zm-2.8-3.63a17.93,17.93,0,0,0,5.6,0V418.61a17.93,17.93,0,0,0-5.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M467.41,416.7H431.1c-.76,0-1.48.54-1.48,4.47s.72,4.47,1.48,4.47h13.69v39.14c0,.76.54,1.47,4.47,1.47s4.47-.71,4.47-1.47V425.64h13.68c.77,0,1.48-.54,1.48-4.47S468.18,416.7,467.41,416.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M449.26,468c-2,0-6.18,0-6.18-3.18V427.34h-12c-3.18,0-3.18-4.17-3.18-6.17s0-6.18,3.18-6.18h36.31c3.19,0,3.19,4.18,3.19,6.18s0,6.17-3.19,6.17h-12v37.44C455.43,468,451.26,468,449.26,468Zm-2.77-3.63a17.55,17.55,0,0,0,5.54,0V423.94H467a17.55,17.55,0,0,0,0-5.54H431.55a17.55,17.55,0,0,0,0,5.54h14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M519.3,417.16c-1.66-.58-7.94-.73-9.12.75l-11.31,17.61-11.34-17.59c-1.1-1.46-7.34-1.35-9-.78-.94.31-1.14.84-1.14,1.24v.24l17,26.51v19.47c0,.42,0,1.69,4.5,1.69s4.5-1.27,4.5-1.69V445.14l17-26.5v-.25C520.39,418,520.2,417.48,519.3,417.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M498.85,468c-1.54,0-6.21,0-6.21-3.39v-19l-17-26.51v-.74a3,3,0,0,1,2.3-2.86c1.64-.55,9.05-1.13,10.93,1.38l.07.1,9.91,15.36,10-15.52c2-2.47,9.46-1.84,11-1.29h0a3,3,0,0,1,2.22,2.83v.75l-17,26.51v19C505.05,468,500.38,468,498.85,468Zm-2.8-3.72a12.76,12.76,0,0,0,5.59,0V444.64l16.7-26c-1.74-.37-5.89-.26-6.83.34l-12.63,19.67L486.19,419c-.94-.59-5-.7-6.79-.34l16.65,26ZM511.45,419Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 274.34,
    y: 415.42,
    width: 13.07,
    height: 13.16,
    rx: 4.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMifinity);
export default __webpack_public_path__ + "static/media/mifinity.c06c4b11ad7dc5644b542ca5c34ce51c.svg";
export { ForwardRef as ReactComponent };